export default __webpack_public_path__ + "static/media/Scarlet Necklace.cd8ab45d.jpg";